
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

interface Team {
  id: string;
  name: string;
  created_at: string;
  updated_at: string;
  owner_id?: string;
  memberCount?: number;
}

interface TeamListProps {
  teams: Team[];
  isLoading: boolean;
  onManageTeam: (id: string, name: string) => void;
}

export const TeamList = ({ teams, isLoading, onManageTeam }: TeamListProps) => {
  if (isLoading) {
    return (
      <div className="py-4 flex justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }

  if (teams.length === 0) {
    return (
      <p className="text-center text-muted-foreground py-4">No teams yet. Create your first team above.</p>
    );
  }

  return (
    <div className="space-y-2">
      {teams.map((team) => (
        <Card key={team.id} className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="font-medium">{team.name}</h3>
              <p className="text-sm text-muted-foreground">
                Members: {team.memberCount || 0}
              </p>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={() => onManageTeam(team.id, team.name)}
            >
              Manage
            </Button>
          </div>
        </Card>
      ))}
    </div>
  );
};
